import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Globe, Palette, Instagram, Music2, Globe2, MessageCircle } from 'lucide-react';
const services = [{
  icon: <Globe size={24} className="text-white" data-id="element-172" />,
  title: 'Página Web',
  desc: 'Tu negocio en internet las 24hs. Que te encuentren aunque estés atendiendo el local.'
}, {
  icon: <Palette size={24} className="text-white" data-id="element-173" />,
  title: 'Identidad Visual',
  desc: 'Logo, paleta, tipografía. Lo primero que ven. Lo que queda en la memoria.'
}, {
  icon: <Instagram size={24} className="text-white" data-id="element-174" />,
  title: 'Instagram & Facebook',
  desc: 'Feed con identidad. Presencia que genera confianza y atrae clientes reales.'
}, {
  icon: <Music2 size={24} className="text-white" data-id="element-175" />,
  title: 'TikTok',
  desc: 'El formato que más crece con turistas jóvenes. Alcance orgánico real.'
}, {
  icon: <Globe2 size={24} className="text-white" data-id="element-176" />,
  title: 'Gestión de Dominio',
  desc: 'Tu nombre propio en internet. Sin depender de plataformas de terceros.'
}, {
  icon: <MessageCircle size={24} className="text-white" data-id="element-177" />,
  title: 'Soporte Directo',
  desc: 'WhatsApp + llamadas. Sin formularios ni esperas. Hablás con nosotros.'
}];
export function Services() {
  return <section id="servicios" className="py-20 md:py-32 bg-negro px-5 md:px-8 relative overflow-hidden" data-id="element-178">
      <div className="absolute inset-0 bg-noise" data-id="element-179"></div>

      <div className="max-w-[1180px] mx-auto relative z-10" data-id="element-180">
        <div className="text-center mb-16" data-id="element-181">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-ambar font-nunito text-sm uppercase tracking-[0.1em] font-bold block mb-4" data-id="element-182">
            Lo que hacemos
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-4xl lg:text-5xl font-playfair font-bold text-white mb-6" data-id="element-183">
            Qué hacemos por tu negocio.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-arena/60 font-nunito text-lg max-w-[600px] mx-auto" data-id="element-184">
            No vendemos paquetes genéricos. Trabajamos según lo que cada negocio
            necesita.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-185">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1 * index
        }} className="bg-arena/[0.06] border border-arena/[0.1] rounded-[14px] p-8 hover:bg-arena/[0.1] hover:-translate-y-[5px] transition-all duration-250 group relative overflow-hidden" data-id="element-186">
              <div className="absolute top-0 left-0 right-0 h-[3px] bg-terracota opacity-0 group-hover:opacity-100 transition-opacity duration-250" data-id="element-187"></div>

              <div className="flex items-start justify-between mb-6" data-id="element-188">
                <div className="w-12 h-12 rounded-full bg-terracota flex items-center justify-center" data-id="element-189">
                  {service.icon}
                </div>
                {service.badge}
              </div>

              <h3 className="text-xl font-playfair font-bold text-white mb-3" data-id="element-190">
                {service.title}
              </h3>
              <p className="text-arena/70 font-nunito text-sm leading-relaxed" data-id="element-191">
                {service.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}